<script>
import axios from '@/utils/axios';
import { leadImportConfigByPlatform } from '@/utils/admin';

export default {
  inject: ['setLoading'],
  data() {
    return {
      errors: {},
      title: "CRM",
      text: "CRM",
      text1: "Import from Aajjo",
      start_time: '',
      end_time: '',
      alert_type: '',
      alert_message: '',
      platform: 'Aajjo',
      import_configs: []
    }
  },

  mounted() {
    this.importConfig();
  },

  methods: {

    async importConfig() {
      this.setLoading(true);
      try {
        const response = await leadImportConfigByPlatform(this.platform);
        this.import_configs = response.data.data;
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.setLoading(false);
      }
    },

    async syncLeads() {
  this.errors = {};
  this.setLoading(true);
  try {
        const payload = {
        from_date: this.$formatDate(this.start_time, 'YYYY-MM-DD HH:mm:ss'),  
        to_date:   this.$formatDate(this.end_time, 'YYYY-MM-DD HH:mm:ss')  
        };
    const query_string = new URLSearchParams(payload).toString();
    const response = await axios.get(`/leads/import/aajjo?${query_string}`);
    const message = `${response.data.data.message} [Fetched : ${response.data.data.total_fetched} and Saved : ${response.data.data.saved_count}]`;
    this.alert_type = "alert-success";
    this.alert_message = message;
  } catch (error) {
    if (error.type === 'validation') {
      this.errors = error.errors; 
    } else {
      this.alert_type = "alert-danger";
      this.alert_message = error.message;
    }
  } finally {
    this.setLoading(false);
  }
}

  }
};
</script>

<style scoped>
.bg-success-light {
  background-color: #d4edda !important;
}

.bg-danger-light {
  background-color: #f8d7da !important;
}

.form-control:focus {
  border-color: #7367f0;
  box-shadow: 0 0 0 0.25rem rgba(115,103,240,0.2);
  transform: translateY(-1px);
}
</style>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="">
          <router-link :to="{name: 'leads-list'}" class="btn btn-primary btn-sm">
            <i class="ti ti-chevrons-left"></i> Leads
          </router-link>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div class="card" style="background-color:#7367f01f;">
        <div class="card-body">
          <div class="indiamart-card">
            <h5><strong>Import your Clients to Algo CRM received in Aajjo and start engaging with them today.</strong></h5>
          </div>
        </div>
      </div>

      <div :class="['alert', 'alert-dismissible', 'fade', 'show', alert_type]" v-if="alert_message">
        <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        <strong>{{ alert_message }}</strong>
      </div>

      <div class="card" style="background-color:#7367f01f;">
        <div class="card-body p-5">
          <div class="text-center mb-4">
            <h5 class="fw-bold text-dark mb-1">Sync Aajjo Leads</h5>
            <small>Last Sync At: <span>{{ $formatDate(import_configs?.last_sync_at, 'DD MMM, YYYY @ hh:mm A') }}</span></small>
            <p class="text-muted mb-0">Select date range to import client enquiries</p>
          </div>
          <form @submit.prevent="syncLeads">
            <div class="row g-4 justify-content-center">
              <div class="col-lg-8">
                <div class="row g-3 align-items-end">
                  <div class="col-md-6">
                    <label class="form-label fw-semibold text-dark mb-2">From Date</label>
                    <div class="position-relative">
                      <input type="datetime-local" class="form-control form-control-lg rounded-pill ps-5 pe-4 py-3 shadow-sm" v-model="start_time" id="start_date">
                      <i class="fas fa-calendar-alt position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                    </div>
                    <div class="text-danger small" v-if="errors.start_time">{{ errors.start_time[0] }}</div>
                  </div>

                  <div class="col-md-6">
                    <label class="form-label fw-semibold text-dark mb-2">To Date</label>
                    <div class="position-relative">
                      <input type="datetime-local" class="form-control form-control-lg rounded-pill ps-5 pe-4 py-3 shadow-sm" v-model="end_time" id="end_date">
                      <i class="fas fa-calendar-alt position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                    </div>
                    <div class="text-danger small" v-if="errors.end_time">{{ errors.end_time[0] }}</div>
                  </div>

                  <div class="col-12 text-center pt-2">
                    <button type="submit" class="btn btn-lg btn-primary w-100 w-md-50 mx-auto px-5 py-3 rounded-pill shadow-lg fs-24" id="import_btn">
                      <i class="fas fa-cloud-download-alt me-2"></i>Sync Leads Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

    </div>

    <app-footer></app-footer>
  </div>
  <!-- /Page Wrapper -->
</template>